import * as Inovx from '@shared';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var BaseService = Inovx.Shared.Flux.BaseService;
var url = `${UrlUtilities.getApiUrl()}/DiagnosticsApi/api/Diagnostics`;

var DiagnosticsServices: IDiagnosticsServices = {
    ...BaseService,

    getLogs: function (request: LogRequestObject, successCallback: (retData: any[]) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        return BaseService.postJson(`${url}/LogMessages`,
            { ...request },
            (retData: any[]) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                if (error.statusText !== 'abort' && !ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            }
        );
    },
    getCSV: function (request: LogRequestObject, successCallback: (retData: null) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        return BaseService.postJson(`${url}/LogCSV`,
            { ...request },
            (retData: any) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                if (error.statusText !== 'abort' && !ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            }
        );
    },
    getDetails: function (diagnosticID: string, successCallback: (retData: any[]) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        return this.get(`${url}/LogDetail`,
            { id: diagnosticID },
            (retData: any[]) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                if (error.statusText !== 'abort' && !ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            }
        );
    }
};

export default DiagnosticsServices;
